import { RoomClosureReasonsStateInterface } from '.';

function state(): RoomClosureReasonsStateInterface {
  return {
    roomClosureReasons: [],
  };
}

export default state;
